import { __, invertObj, prop } from 'ramda';

import { THEMATIC } from '../../../types/filters';

const PRISMIC_TO_TYPE_THEMATIC = {
  'Transitions écologiques': THEMATIC.ECOLOGY,
  'Transformation numérique': THEMATIC.DIGITAL,
  'Services à la personne': THEMATIC.PEOPLE,
  'Banque et assurance': THEMATIC.BANK,
  'Excellence logistique': THEMATIC.LOGISTICS,
  'Développement Territorial': THEMATIC.DT,
};

export const toThematicType = prop(__, PRISMIC_TO_TYPE_THEMATIC);
export const toThematicPrismic = prop(__, invertObj(PRISMIC_TO_TYPE_THEMATIC));
